import { render, staticRenderFns } from "./button-cart.vue?vue&type=template&id=1831a403&"
import script from "./button-cart.vue?vue&type=script&lang=ts&"
export * from "./button-cart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports